import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import './DockToast.css';

const DockToast = React.forwardRef(({ isVisible, message }, ref) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          ref={ref}
          className="dock-toast"
          initial={{ opacity: 0, y: 20, x: '-50%' }}
          animate={{
            opacity: 1,
            y: [0, -8, 0],
            x: '-50%'
          }}
          exit={{ opacity: 0, y: 20, x: '-50%' }}
          transition={{
            opacity: { duration: 0.4 },
            y: {
              duration: 1.5,
              repeat: Infinity,
              ease: "easeInOut"
            }
          }}
        >
          {message}
        </motion.div>
      )}
    </AnimatePresence>
  );
});

DockToast.displayName = 'DockToast';

export default DockToast;
